<!-- Custom styling (--cerulean, etc.) are applied to this node -->
<!-- They come through user land -->
<div class="mdc-form-field">

    <div class="mdc-checkbox" ref="checkboxElm">

        <input type="checkbox" class="mdc-checkbox__native-control" :id="id" ref="native"
            :checked="checked" :value="value"
            :indeterminate.prop="indeterminate" :disabled="disabled"
            @change="onInput" />

        <div class="mdc-checkbox__background">
            <!-- Do not use mom-icon component here -->
            <svg viewBox="0 0 24 24" class="mdc-checkbox__checkmark" :class="{ 'mdc-checkbox--unchecked': !checked }">
                <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
            </svg>
            <div class="mdc-checkbox__mixedmark"></div>
        </div>
    </div>

    <label class="mdc-checkbox__label" :for="id"><slot></slot></label>
</div>
